import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InternationalizationService {
  languagesAlexa=[
    {"code":"en-US","name":"English (US)","nativeName":"English"},
    {"code":"en-AU","name":"English (AU)","nativeName":"English"},
    {"code":"en-CA","name":"English (CA)","nativeName":"English"},
    {"code":"en-GB","name":"English (UK)","nativeName":"English"},
    {"code":"en-IN","name":"English (IN)","nativeName":"English"},

    {"code":"de-DE","name":"German (DE)","nativeName":"German"},

    {"code":"fr-CA","name":"French (CA)","nativeName":"French"},
    {"code":"fr-FR","name":"French (FR)","nativeName":"French"},
    
    {"code":"es-ES","name":"Spanish (ES)","nativeName":"Spanish"},
    {"code":"es-MX","name":"Spanish (MX)","nativeName":"Spanish"},
    {"code":"es-US","name":"Spanish (US)","nativeName":"Spanish"}, 

    {"code":"hi-IN","name":"Hindi (IN)","nativeName":"Hindi"},
    {"code":"it-IT","name":"Italian (IT)","nativeName":"Italian"},
    {"code":"ja-JP","name":"JapaneseV(JP)","nativeName":"Japanese"},
    {"code":"pt-BR","name":"Portuguese (BR)","nativeName":"Portuguese"},
  ]
  countries=[ 
    {name: 'Afghanistan', code: 'AF' , currency: "EURO",}, 
    {name: 'Åland Islands', code: 'AX' , currency: "EURO",}, 
    {name: 'Albania', code: 'AL' , currency: "EURO",}, 
    {name: 'Algeria', code: 'DZ' , currency: "EURO",}, 
    {name: 'American Samoa', code: 'AS'}, 
    {name: 'AndorrA', code: 'AD'}, 
    {name: 'Angola', code: 'AO'}, 
    {name: 'Anguilla', code: 'AI'}, 
    {name: 'Antarctica', code: 'AQ'}, 
    {name: 'Antigua and Barbuda', code: 'AG'}, 
    {name: 'Argentina', code: 'AR'}, 
    {name: 'Armenia', code: 'AM'}, 
    {name: 'Aruba', code: 'AW'}, 
    {name: 'Australia', code: 'AU'}, 
    {name: 'Austria', code: 'AT'}, 
    {name: 'Azerbaijan', code: 'AZ'}, 
    {name: 'Bahamas', code: 'BS'}, 
    {name: 'Bahrain', code: 'BH'}, 
    {name: 'Bangladesh', code: 'BD'}, 
    {name: 'Barbados', code: 'BB'}, 
    {name: 'Belarus', code: 'BY'}, 
    {name: 'Belgium', code: 'BE'}, 
    {name: 'Belize', code: 'BZ'}, 
    {name: 'Benin', code: 'BJ'}, 
    {name: 'Bermuda', code: 'BM'}, 
    {name: 'Bhutan', code: 'BT'}, 
    {name: 'Bolivia', code: 'BO'}, 
    {name: 'Bosnia and Herzegovina', code: 'BA'}, 
    {name: 'Botswana', code: 'BW'}, 
    {name: 'Bouvet Island', code: 'BV'}, 
    {name: 'Brazil', code: 'BR'}, 
    {name: 'British Indian Ocean Territory', code: 'IO'}, 
    {name: 'Brunei Darussalam', code: 'BN'}, 
    {name: 'Bulgaria', code: 'BG'}, 
    {name: 'Burkina Faso', code: 'BF'}, 
    {name: 'Burundi', code: 'BI'}, 
    {name: 'Cambodia', code: 'KH'}, 
    {name: 'Cameroon', code: 'CM'}, 
    {name: 'Canada', code: 'CA'}, 
    {name: 'Cape Verde', code: 'CV'}, 
    {name: 'Cayman Islands', code: 'KY'}, 
    {name: 'Central African Republic', code: 'CF'}, 
    {name: 'Chad', code: 'TD'}, 
    {name: 'Chile', code: 'CL'}, 
    {name: 'China', code: 'CN'}, 
    {name: 'Christmas Island', code: 'CX'}, 
    {name: 'Cocos (Keeling) Islands', code: 'CC'}, 
    {name: 'Colombia', code: 'CO'}, 
    {name: 'Comoros', code: 'KM'}, 
    {name: 'Congo', code: 'CG'}, 
    {name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
    {name: 'Cook Islands', code: 'CK'}, 
    {name: 'Costa Rica', code: 'CR'}, 
    {name: 'Cote D\'Ivoire', code: 'CI'}, 
    {name: 'Croatia', code: 'HR'}, 
    {name: 'Cuba', code: 'CU'}, 
    {name: 'Cyprus', code: 'CY'}, 
    {name: 'Czech Republic', code: 'CZ'}, 
    {name: 'Denmark', code: 'DK'}, 
    {name: 'Djibouti', code: 'DJ'}, 
    {name: 'Dominica', code: 'DM'}, 
    {name: 'Dominican Republic', code: 'DO'}, 
    {name: 'Ecuador', code: 'EC'}, 
    {name: 'Egypt', code: 'EG'}, 
    {name: 'El Salvador', code: 'SV'}, 
    {name: 'Equatorial Guinea', code: 'GQ'}, 
    {name: 'Eritrea', code: 'ER'}, 
    {name: 'Estonia', code: 'EE'}, 
    {name: 'Ethiopia', code: 'ET'}, 
    {name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
    {name: 'Faroe Islands', code: 'FO'}, 
    {name: 'Fiji', code: 'FJ'}, 
    {name: 'Finland', code: 'FI'}, 
    {name: 'France', code: 'FR'}, 
    {name: 'French Guiana', code: 'GF'}, 
    {name: 'French Polynesia', code: 'PF'}, 
    {name: 'French Southern Territories', code: 'TF'}, 
    {name: 'Gabon', code: 'GA'}, 
    {name: 'Gambia', code: 'GM'}, 
    {name: 'Georgia', code: 'GE'}, 
    {name: 'Germany', code: 'DE'}, 
    {name: 'Ghana', code: 'GH'}, 
    {name: 'Gibraltar', code: 'GI'}, 
    {name: 'Greece', code: 'GR'}, 
    {name: 'Greenland', code: 'GL'}, 
    {name: 'Grenada', code: 'GD'}, 
    {name: 'Guadeloupe', code: 'GP'}, 
    {name: 'Guam', code: 'GU'}, 
    {name: 'Guatemala', code: 'GT'}, 
    {name: 'Guernsey', code: 'GG'}, 
    {name: 'Guinea', code: 'GN'}, 
    {name: 'Guinea-Bissau', code: 'GW'}, 
    {name: 'Guyana', code: 'GY'}, 
    {name: 'Haiti', code: 'HT'}, 
    {name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
    {name: 'Holy See (Vatican City State)', code: 'VA'}, 
    {name: 'Honduras', code: 'HN'}, 
    {name: 'Hong Kong', code: 'HK'}, 
    {name: 'Hungary', code: 'HU'}, 
    {name: 'Iceland', code: 'IS'}, 
    {name: 'India', code: 'IN'}, 
    {name: 'Indonesia', code: 'ID'}, 
    {name: 'Iran, Islamic Republic Of', code: 'IR'}, 
    {name: 'Iraq', code: 'IQ'}, 
    {name: 'Ireland', code: 'IE'}, 
    {name: 'Isle of Man', code: 'IM'}, 
    {name: 'Israel', code: 'IL'}, 
    {name: 'Italy', code: 'IT'}, 
    {name: 'Jamaica', code: 'JM'}, 
    {name: 'Japan', code: 'JP'}, 
    {name: 'Jersey', code: 'JE'}, 
    {name: 'Jordan', code: 'JO'}, 
    {name: 'Kazakhstan', code: 'KZ'}, 
    {name: 'Kenya', code: 'KE'}, 
    {name: 'Kiribati', code: 'KI'}, 
    {name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
    {name: 'Korea, Republic of', code: 'KR'}, 
    {name: 'Kuwait', code: 'KW'}, 
    {name: 'Kyrgyzstan', code: 'KG'}, 
    {name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
    {name: 'Latvia', code: 'LV'}, 
    {name: 'Lebanon', code: 'LB'}, 
    {name: 'Lesotho', code: 'LS'}, 
    {name: 'Liberia', code: 'LR'}, 
    {name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
    {name: 'Liechtenstein', code: 'LI'}, 
    {name: 'Lithuania', code: 'LT'}, 
    {name: 'Luxembourg', code: 'LU'}, 
    {name: 'Macao', code: 'MO'}, 
    {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
    {name: 'Madagascar', code: 'MG'}, 
    {name: 'Malawi', code: 'MW'}, 
    {name: 'Malaysia', code: 'MY'}, 
    {name: 'Maldives', code: 'MV'}, 
    {name: 'Mali', code: 'ML'}, 
    {name: 'Malta', code: 'MT'}, 
    {name: 'Marshall Islands', code: 'MH'}, 
    {name: 'Martinique', code: 'MQ'}, 
    {name: 'Mauritania', code: 'MR'}, 
    {name: 'Mauritius', code: 'MU'}, 
    {name: 'Mayotte', code: 'YT'}, 
    {name: 'Mexico', code: 'MX'}, 
    {name: 'Micronesia, Federated States of', code: 'FM'}, 
    {name: 'Moldova, Republic of', code: 'MD'}, 
    {name: 'Monaco', code: 'MC'}, 
    {name: 'Mongolia', code: 'MN'}, 
    {name: 'Montserrat', code: 'MS'}, 
    {name: 'Morocco', code: 'MA'}, 
    {name: 'Mozambique', code: 'MZ'}, 
    {name: 'Myanmar', code: 'MM'}, 
    {name: 'Namibia', code: 'NA'}, 
    {name: 'Nauru', code: 'NR'}, 
    {name: 'Nepal', code: 'NP'}, 
    {name: 'Netherlands', code: 'NL'}, 
    {name: 'Netherlands Antilles', code: 'AN'}, 
    {name: 'New Caledonia', code: 'NC'}, 
    {name: 'New Zealand', code: 'NZ'}, 
    {name: 'Nicaragua', code: 'NI'}, 
    {name: 'Niger', code: 'NE'}, 
    {name: 'Nigeria', code: 'NG'}, 
    {name: 'Niue', code: 'NU'}, 
    {name: 'Norfolk Island', code: 'NF'}, 
    {name: 'Northern Mariana Islands', code: 'MP'}, 
    {name: 'Norway', code: 'NO'}, 
    {name: 'Oman', code: 'OM'}, 
    {name: 'Pakistan', code: 'PK'}, 
    {name: 'Palau', code: 'PW'}, 
    {name: 'Palestinian Territory, Occupied', code: 'PS'}, 
    {name: 'Panama', code: 'PA'}, 
    {name: 'Papua New Guinea', code: 'PG'}, 
    {name: 'Paraguay', code: 'PY'}, 
    {name: 'Peru', code: 'PE'}, 
    {name: 'Philippines', code: 'PH'}, 
    {name: 'Pitcairn', code: 'PN'}, 
    {name: 'Poland', code: 'PL'}, 
    {name: 'Portugal', code: 'PT'}, 
    {name: 'Puerto Rico', code: 'PR'}, 
    {name: 'Qatar', code: 'QA'}, 
    {name: 'Reunion', code: 'RE'}, 
    {name: 'Romania', code: 'RO'}, 
    {name: 'Russian Federation', code: 'RU'}, 
    {name: 'RWANDA', code: 'RW'}, 
    {name: 'Saint Helena', code: 'SH'}, 
    {name: 'Saint Kitts and Nevis', code: 'KN'}, 
    {name: 'Saint Lucia', code: 'LC'}, 
    {name: 'Saint Pierre and Miquelon', code: 'PM'}, 
    {name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
    {name: 'Samoa', code: 'WS'}, 
    {name: 'San Marino', code: 'SM'}, 
    {name: 'Sao Tome and Principe', code: 'ST'}, 
    {name: 'Saudi Arabia', code: 'SA'}, 
    {name: 'Senegal', code: 'SN'}, 
    {name: 'Serbia and Montenegro', code: 'CS'}, 
    {name: 'Seychelles', code: 'SC'}, 
    {name: 'Sierra Leone', code: 'SL'}, 
    {name: 'Singapore', code: 'SG'}, 
    {name: 'Slovakia', code: 'SK'}, 
    {name: 'Slovenia', code: 'SI'}, 
    {name: 'Solomon Islands', code: 'SB'}, 
    {name: 'Somalia', code: 'SO'}, 
    {name: 'South Africa', code: 'ZA'}, 
    {name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
    {name: 'Spain', code: 'ES'}, 
    {name: 'Sri Lanka', code: 'LK'}, 
    {name: 'Sudan', code: 'SD'}, 
    {name: 'Suriname', code: 'SR'}, 
    {name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
    {name: 'Swaziland', code: 'SZ'}, 
    {name: 'Sweden', code: 'SE'}, 
    {name: 'Switzerland', code: 'CH'}, 
    {name: 'Syrian Arab Republic', code: 'SY'}, 
    {name: 'Taiwan, Province of China', code: 'TW'}, 
    {name: 'Tajikistan', code: 'TJ'}, 
    {name: 'Tanzania, United Republic of', code: 'TZ'}, 
    {name: 'Thailand', code: 'TH'}, 
    {name: 'Timor-Leste', code: 'TL'}, 
    {name: 'Togo', code: 'TG'}, 
    {name: 'Tokelau', code: 'TK'}, 
    {name: 'Tonga', code: 'TO'}, 
    {name: 'Trinidad and Tobago', code: 'TT'}, 
    {name: 'Tunisia', code: 'TN'}, 
    {name: 'Turkey', code: 'TR'}, 
    {name: 'Turkmenistan', code: 'TM'}, 
    {name: 'Turks and Caicos Islands', code: 'TC'}, 
    {name: 'Tuvalu', code: 'TV'}, 
    {name: 'Uganda', code: 'UG'}, 
    {name: 'Ukraine', code: 'UA'}, 
    {name: 'United Arab Emirates', code: 'AE'}, 
    {name: 'United Kingdom', code: 'GB'}, 
    {name: 'United States', code: 'US'}, 
    {name: 'United States Minor Outlying Islands', code: 'UM'}, 
    {name: 'Uruguay', code: 'UY'}, 
    {name: 'Uzbekistan', code: 'UZ'}, 
    {name: 'Vanuatu', code: 'VU'}, 
    {name: 'Venezuela', code: 'VE'}, 
    {name: 'Viet Nam', code: 'VN'}, 
    {name: 'Virgin Islands, British', code: 'VG'}, 
    {name: 'Virgin Islands, U.S.', code: 'VI'}, 
    {name: 'Wallis and Futuna', code: 'WF'}, 
    {name: 'Western Sahara', code: 'EH'}, 
    {name: 'Yemen', code: 'YE'}, 
    {name: 'Zambia', code: 'ZM'}, 
    {name: 'Zimbabwe', code: 'ZW'} 
  ];
  countriesDF=[
   {
      name: "Andorra", code: 'AF', currency: "EURO",},
      {
        "name": "American Samoa",currency: "USD",
      },
   {
      name: "United Arab Emirates", currency: "AED",
  
    },
    {
      "name": "Argentina", currency: "ARS",
    },
   {
      "name": "Afghanistan", currency: "AFN",
    },
   {
      "name": "United States",currency: "USD,USN,USS",
   
    },
   {
      "name": "Antigua and Barbuda", currency: "XCD",
    },
  {
      "name": "Anguilla", currency: "XCD",
    },
 {
      "name": "Albania",  currency: "ALL",
    },
  {
      "name": "Armenia",currency: "AMD",
    },
   {
      "name": "Angola",currency: "AOA",
    },


 
    {
      "name": "Austria",currency: "EURO",

    },
 {
      "name": "Australia",currency: "AUD",
    },
    {
      "name": "Aruba",currency: "AWG",
    },
   {
      "name": "Åland",currency: "EURO",
    },
    {
      "name": "Azerbaijan",currency: "AZN",
    },
   {
      "name": "Bosnia and Herzegovina",currency: "BAM",
    },
  {
      "name": "Barbados",currency: "BBD",
    },
   {
      "name": "Bangladesh",currency: "BDT",
    },
  {
      "name": "Belgium",currency: "EURO",
    },
 {
      "name": "Burkina Faso",currency: "XOF",
    },
   {
      "name": "Bulgaria",currency: "BGN",
    },
   {
      "name": "Bahrain",
currency: "BHD",
    },
     {
      "name": "Burundi",currency: "BIF",

    },
    {
      "name": "Benin",currency: "XOF",
    
    },
  {
      "name": "Saint Barthélemy",currency: "EURO",
     
    },
  {
      "name": "Bermuda", currency: "BMD",
   
    },
 {
      "name": "Brunei",currency: "BND",
   
    },
 {
      "name": "Bolivia", currency: "BOB,BOV",
    
    },
   {
      "name": "Bonaire",currency: "USD",
    
    },
 {
      "name": "Brazil", currency: "BRL",
    
    },
 {
      "name": "Bahamas", currency: "BSD",
     
    },
  {
      "name": "Bhutan",currency: "BTN,INR",
     
    },
   {
      "name": "Bouvet Island", currency: "NOK",
    
    },
   {
      "name": "Botswana", currency: "BWP",
   
    },
    {
      "name": "Belarus",currency: "BYR",
     
    },
     {
      "name": "Belize", currency: "BZD",
  
    },
  {
      "name": "Canada",currency: "CAD",
    
    },
   {
      "name": "Cocos [Keeling] Islands",currency: "AUD",
    
    },
   {
      "name": "Democratic Republic of the Congo",currency: "CDF",
   
    },
    {
      "name": "Central African Republic", currency: "XAF",
    
    },
  {
      "name": "Republic of the Congo",currency: "XAF",
   
    },
 {
      "name": "Switzerland", currency: "CHE,CHF,CHW",
    
    },
   {
      "name": "Ivory Coast",currency: "XOF",
   
    },
   {
      "name": "Cook Islands",currency: "NZD",
    
    },

  {
      "name": "Cameroon",currency: "XAF",
  
    },
  {
      "name": "China",currency: "CNY",
    
    },
     {
      "name": "Colombia",currency: "COP",
   
    },
     {
      "name": "Costa Rica",currency: "CRC",
   
    },
   {
      "name": "Cuba",currency: "CUC,CUP",
    
    },
 
  {
      "name": "Curacao",currency: "ANG",
    
    },
  {
      "name": "Christmas Island",currency: "AUD",
   
    },
    {
      "name": "Cyprus",currency: "EURO",
  
    },
  {
      "name": "Czech Republic",currency: "CZK",
   
    },
  {
      "name": "Germany",currency: "EURO",
   
    },
 {
      "name": "Djibouti",currency: "DJF",
  
    },
    {
      "name": "Denmark",currency: "DKK",
   
    },
   {
      "name": "Dominica",currency: "XCD",
   },
 {

      "name": "Dominican Republic",currency: "DOP",
   
    },
  {
      "name": "Algeria",currency: "DZD",
    
    },
 {
      "name": "Ecuador",currency: "USD",
    
    },
 {
      "name": "Estonia",currency: "EURO",
     
    },
   {
      "name": "Egypt",currency: "EGP",
  
    },
  {
      "name": "Western Sahara",currency: "MAD,DZD,MRU",
  
    },
    {
      "name": "Eritrea",currency: "ERN",
  
    },
   {
      "name": "Spain",currency: "EURO",
  
    },
   {
      "name": "Ethiopia",currency: "ETB",
 
    },
    {
      "name": "Finland",currency: "EURO",
    
    },
   {
      "name": "Fiji", currency: "FJD",
  
    },
  {
      "name": "Falkland Islands",currency: "FKP",
   
    },
   {
      "name": "Micronesia",currency: "USD",
  
    },
 {
      "name": "Faroe Islands",currency: "DKK",
   
    },
     {
      "name": "France",currency: "EURO",
    
    },
  {
      "name": "Gabon", currency: "XAF",
   
    },
    {
      "name": "United Kingdom",currency: "GBP",
   
    },

  
   {
      "name": "Georgia",currency: "GEL",
  
    },
   {
      "name": "French Guiana",currency: "EURO",
  
    },
   {
      "name": "Guernsey",currency: "GBP",
   
    },
    {
      "name": "Ghana",currency: "GHS",
     
    },
  {
      "name": "Gibraltar",currency: "GIP",
    
    },
 {
      "name": "Greenland",currency: "DKK",
   
    },
 {
      "name": "Gambia",
   
      currency: "GMD",
    
    },
     {
      "name": "Guinea",
    
      currency: "GNF",
    
    },
{
      "name": "Guadeloupe",
   
      currency: "EURO",
    
      
    },
  {
      "name": "Equatorial Guinea",

      currency: "XAF",
   
    },
 {
      "name": "Greece",
     
      currency: "EURO",
     
    },
   {
      "name": "South Georgia and the South Sandwich Islands",
  
      currency: "GBP",
   
    },
    {
      "name": "Guatemala",
   
      currency: "GTQ",
    
    },
  {
      "name": "Guam",
    
      currency: "USD",
  
    },
   {
      "name": "Guinea-Bissau",
    
      currency: "XOF",
   
    },
   {
      "name": "Guyana",
  
      currency: "GYD",
    
    },
   {
      "name": "Hong Kong",
   
      currency: "HKD",
   
    },
  {
      "name": "Heard Island and McDonald Islands",
   
      currency: "AUD",
     
    },
    {
      "name": "Honduras",
   
      currency: "HNL",
   
    },
   {
      "name": "Croatia",
  
      currency: "HRK",
     
    },
   {
      "name": "Haiti",
    
      currency: "HTG,USD",
    
    },
 {
      "name": "Hungary",
 
      currency: "HUF",
    
    },
     {
      "name": "Indonesia",
   
      currency: "IDR",
    
    },
 {
      "name": "Ireland",
   
      currency: "EURO",
 
    },
    {
      "name": "Israel",
      
      currency: "ILS",
  
    },
     {
      "name": "Isle of Man",
  
      currency: "GBP",
    
    },
  {
      "name": "India",
  
      currency: "INR",
    
    },
  {
      "name": "British Indian Ocean Territory",
   
      currency: "USD",
    
    },
   {
      "name": "Iraq",
    
      currency: "IQD",
    
    },
    {
      "name": "Iran",
     
      currency: "IRR",
    
    },
   {
      "name": "Iceland",
 
      currency: "ISK",
     
    },
   {
      "name": "Italy",
   
      currency: "EURO",
    
    },
  {
      "name": "Jersey",

      currency: "GBP",
     
    },
    {
      "name": "Jamaica",
  
      currency: "JMD",
    
    },
   {
      "name": "Jordan",
    
      currency: "JOD",
    
    },
   {
      "name": "Japan",
 
      currency: "JPY",
  
    },
 {
      "name": "Kenya",
    
      currency: "KES",
  
    },
   {
      "name": "Kyrgyzstan",
  
      currency: "KGS",
    
      
    },
  {
      "name": "Cambodia",
   
   
      currency: "KHR",
    
    },
   {
      "name": "Kiribati",
  
      currency: "AUD",
    
    },
 {
      "name": "Comoros",
    
      currency: "KMF",
   
    },
     {
      "name": "Saint Kitts and Nevis",
   
      currency: "XCD",
    
    },
    {
      "name": "North Korea",
    
      currency: "KPW",
   
    },
   {
      "name": "South Korea",
    
      currency: "KRW",
    
    },
   {
      "name": "Kuwait",
      currency: "KWD",
 
    },
    {
      "name": "Cayman Islands",

      currency: "KYD",
 
    },
   {
      "name": "Kazakhstan",
   
      currency: "KZT",
  
    },
   {
      "name": "Laos",
  
      currency: "LAK",
    
    },
 {
      "name": "Lebanon",
  
      currency: "LBP",
    
    },
  {
      "name": "Saint Lucia",

      currency: "XCD",
    
    },
     {
      "name": "Liechtenstein",

      currency: "CHF",
    
    },
   {
      "name": "Sri Lanka",
   
      currency: "LKR",
     
   
    },
  {
      "name": "Liberia",
   
      currency: "LRD",
   
    },
 {
      "name": "Lesotho",
  
      currency: "LSL,ZAR",
   
    
    },
 {
      "name": "Lithuania",
  
      currency: "EUROOO",
   
    },
     {
      "name": "Luxembourg",
   
      currency: "EUROOO",
    
    },
 {
      "name": "Latvia",

      currency: "EUROOO",
  
    },
    {
      "name": "Libya",
 
      currency: "LYD",
 
    },
    {
      "name": "Morocco",
 
      currency: "MAD",
    
    },
  {
      "name": "Monaco",currency: "EURO",
     
    },
     {
      "name": "Moldova",currency: "MDL",
     
    },
     {
      "name": "Montenegro",currency: "EUROOO",
  
    },
 {
      "name": "Saint Martin",currency: "EUROOO",
   
    },
   {
      "name": "Madagascar",currency: "MGA",
   
    },
   {
      "name": "Marshall Islands",currency: "USD",
    
    },
  {
      "name": "North Macedonia",currency: "MKD",
   
    },
  {
      "name": "Mali",
    
      currency: "XOF",
     
    },
    {
      "name": "Myanmar [Burma]",
  
      currency: "MMK",
     
    },
    {
      "name": "Mongolia",
  
      currency: "MNT",
   
    },
   {
      "name": "Macao",
  
      currency: "MOP",
    
    },
 {
      "name": "Northern Mariana Islands",
  
      currency: "USD",
   
    },
  {
      "name": "Martinique",
    
      currency: "EUROOO",
    
    },
    {
      "name": "Mauritania",
  
      currency: "MRU",
    
    },
     {
      "name": "Montserrat",
  
      currency: "XCD",
    
    },
   {
      "name": "Malta",

      currency: "EUROOO",
   
    },
    {
      "name": "Mauritius",

      currency: "MUR",
    
    },
 {
      "name": "Maldives",
   
      currency: "MVR",
     
    },
    {
      "name": "Malawi",
   
      currency: "MWK",
    
    },
    {
      "name": "Mexico",
 
      currency: "MXN",
   
    },
     {
      "name": "Malaysia",
     
      currency: "MYR",
     
    },
     {
      "name": "Mozambique",

      currency: "MZN",
    
    },
   {
      "name": "Namibia",
 
      currency: "NAD,ZAR",
  
    },
    {
      "name": "New Caledonia",
 
      currency: "XPF",
    
    },
  {
      "name": "Niger",

      currency: "XOF",
   
    },
    {
      "name": "Norfolk Island",
  
      currency: "AUD",
   
    },
  {
      "name": "Nigeria",
    
      currency: "NGN",
    
    },
   {
      "name": "Nicaragua",
  
      currency: "NIO",
     
    },
    {
      "name": "Netherlands",
   
      currency: "EUROOO",
   
    },
    {
      "name": "Norway",
  
      currency: "NOK",
    
    },
 {
      "name": "Nepal",
 
      currency: "NPR",
 
    },
{
      "name": "Nauru",
  
      currency: "AUD",
     
    },
    {
      "name": "Niue",
  
      currency: "NZD",
    
    },
    {
      "name": "New Zealand",
    
      currency: "NZD",
    
    },
   {
      "name": "Oman",
  
      currency: "OMR",
    
    },
 {
      "name": "Panama",
  
      currency: "PAB,USD",
     
    },
  {
      "name": "Peru",
   
      currency: "PEN",
     
    },
     {
      "name": "French Polynesia",
  
      currency: "XPF",
    
    },
    {
      "name": "Papua New Guinea",
 
      currency: "PGK",
    
    },
  {
      "name": "Philippines",
  
      currency: "PHP",
    
    },
 {
      "name": "Pakistan",
 
      currency: "PKR",
   
    },
   {
      "name": "Poland",
 
      currency: "PLN",
    
    },
    {
      "name": "Saint Pierre and Miquelon",

      currency: "EUROOO",
    
    },
    {
      "name": "Pitcairn Islands",
   
      currency: "NZD",
    
    },
 {
      "name": "Puerto Rico",

      currency: "USD",
  
    },
 {
      "name": "Palestine",

      currency: "ILS",
   
    },
   {
      "name": "Portugal",
 
      currency: "EUROOO",
     
    },
    {
      "name": "Palau",
  
      currency: "USD",
   
    },
    {
      "name": "Paraguay",

      currency: "PYG",
  
    },
    {
      "name": "Qatar",

      currency: "QAR",
    
    },
     {
      "name": "Réunion",

      currency: "EUROOO",
   
    },
   {
      "name": "Romania",
     
      currency: "RON",
     
    },
 {
      "name": "Serbia",
   
      currency: "RSD",
     
    },
  {
      "name": "Russia",
     
      currency: "RUB",
   
    },
   {
      "name": "Rwanda",
   
      currency: "RWF",
     
    },
    {
      "name": "Saudi Arabia",
 
      currency: "SAR",
    
    },
  {
      "name": "Solomon Islands",
   
      currency: "SBD",
  
    },
   {
      "name": "Seychelles",
  
      currency: "SCR",
   
    },
 {
      "name": "Sudan",
  
      currency: "SDG",
    
    },
 {
      "name": "Sweden",
   
      currency: "SEK",
    
    },
     {
      "name": "Singapore",
   
      currency: "SGD",
    
    },
 {
      "name": "Saint Helena",
     
      currency: "SHP",
     
    },
   {
      "name": "Slovenia",
  
      currency: "EUROOO",
    
    },
  {
      "name": "Svalbard and Jan Mayen",

      currency: "NOK",
    
    },
   {
      "name": "Slovakia",
   
      currency: "EUROOO",
    
    },
  {
      "name": "Sierra Leone",
  
      currency: "SLL",
   
    },
     {
      "name": "San Marino",

      currency: "EUROOO",
   
    },
  //  {
  //     "name": "Senegal",
   
  //     currency: "XOF",
   
  //   },
  //   "SO": {
  //     "name": "Somalia",
  //     "native": "Soomaaliya",
  //     "phone": "252",
  //     "continent": "AF",
  //     "capital": "Mogadishu",
  //     currency: "SOS",
  //     "languages": [
  //       "so",
  //       "ar"
  //     ]
  //   },
  //   "SR": {
  //     "name": "Suriname",
  //     "native": "Suriname",
  //     "phone": "597",
  //     "continent": "SA",
  //     "capital": "Paramaribo",
  //     currency: "SRD",
  //     "languages": [
  //       "nl"
  //     ]
  //   },
  //   "SS": {
  //     "name": "South Sudan",
  //     "native": "South Sudan",
  //     "phone": "211",
  //     "continent": "AF",
  //     "capital": "Juba",
  //     currency: "SSP",
  //     "languages": [
  //       "en"
  //     ]
  //   },
  //   "ST": {
  //     "name": "São Tomé and Príncipe",
  //     "native": "São Tomé e Príncipe",
  //     "phone": "239",
  //     "continent": "AF",
  //     "capital": "São Tomé",
  //     currency: "STN",
  //     "languages": [
  //       "pt"
  //     ]
  //   },
  //   "SV": {
  //     "name": "El Salvador",
  //     "native": "El Salvador",
  //     "phone": "503",
  //     "continent": "NA",
  //     "capital": "San Salvador",
  //     currency: "SVC,USD",
  //     "languages": [
  //       "es"
  //     ]
  //   },
  //   "SX": {
  //     "name": "Sint Maarten",
  //     "native": "Sint Maarten",
  //     "phone": "1721",
  //     "continent": "NA",
  //     "capital": "Philipsburg",
  //     currency: "ANG",
  //     "languages": [
  //       "nl",
  //       "en"
  //     ]
  //   },
  //   "SY": {
  //     "name": "Syria",
  //     "native": "سوريا",
  //     "phone": "963",
  //     "continent": "AS",
  //     "capital": "Damascus",
  //     currency: "SYP",
  //     "languages": [
  //       "ar"
  //     ]
  //   },
  //   "SZ": {
  //     "name": "Swaziland",
  //     "native": "Swaziland",
  //     "phone": "268",
  //     "continent": "AF",
  //     "capital": "Lobamba",
  //     currency: "SZL",
  //     "languages": [
  //       "en",
  //       "ss"
  //     ]
  //   },
  //   "TC": {
  //     "name": "Turks and Caicos Islands",
  //     "native": "Turks and Caicos Islands",
  //     "phone": "1649",
  //     "continent": "NA",
  //     "capital": "Cockburn Town",
  //     currency: "USD",
  //     "languages": [
  //       "en"
  //     ]
  //   },
  //   "TD": {
  //     "name": "Chad",
  //     "native": "Tchad",
  //     "phone": "235",
  //     "continent": "AF",
  //     "capital": "N'Djamena",
  //     currency: "XAF",
  //     "languages": [
  //       "fr",
  //       "ar"
  //     ]
  //   },
  //   "TF": {
  //     "name": "French Southern Territories",
  //     "native": "Territoire des Terres australes et antarctiques fr",
  //     "phone": "262",
  //     "continent": "AN",
  //     "capital": "Port-aux-Français",
  //     currency: "EUROOO",
  //     "languages": [
  //       "fr"
  //     ]
  //   },
  //   "TG": {
  //     "name": "Togo",
  //     "native": "Togo",
  //     "phone": "228",
  //     "continent": "AF",
  //     "capital": "Lomé",
  //     currency: "XOF",
  //     "languages": [
  //       "fr"
  //     ]
  //   },
  //   "TH": {
  //     "name": "Thailand",
  //     "native": "ประเทศไทย",
  //     "phone": "66",
  //     "continent": "AS",
  //     "capital": "Bangkok",
  //     currency: "THB",
  //     "languages": [
  //       "th"
  //     ]
  //   },
  //   "TJ": {
  //     "name": "Tajikistan",
  //     "native": "Тоҷикистон",
  //     "phone": "992",
  //     "continent": "AS",
  //     "capital": "Dushanbe",
  //     currency: "TJS",
  //     "languages": [
  //       "tg",
  //       "ru"
  //     ]
  //   },
  //   "TK": {
  //     "name": "Tokelau",
  //     "native": "Tokelau",
  //     "phone": "690",
  //     "continent": "OC",
  //     "capital": "Fakaofo",
  //     currency: "NZD",
  //     "languages": [
  //       "en"
  //     ]
  //   },
  //   "TL": {
  //     "name": "East Timor",
  //     "native": "Timor-Leste",
  //     "phone": "670",
  //     "continent": "OC",
  //     "capital": "Dili",
  //     currency: "USD",
  //     "languages": [
  //       "pt"
  //     ]
  //   },
  //   "TM": {
  //     "name": "Turkmenistan",
  //     "native": "Türkmenistan",
  //     "phone": "993",
  //     "continent": "AS",
  //     "capital": "Ashgabat",
  //     currency: "TMT",
  //     "languages": [
  //       "tk",
  //       "ru"
  //     ]
  //   },
  //   "TN": {
  //     "name": "Tunisia",
  //     "native": "تونس",
  //     "phone": "216",
  //     "continent": "AF",
  //     "capital": "Tunis",
  //     currency: "TND",
  //     "languages": [
  //       "ar"
  //     ]
  //   },
  //   "TO": {
  //     "name": "Tonga",
  //     "native": "Tonga",
  //     "phone": "676",
  //     "continent": "OC",
  //     "capital": "Nuku'alofa",
  //     currency: "TOP",
  //     "languages": [
  //       "en",
  //       "to"
  //     ]
  //   },
  //   "TR": {
  //     "name": "Turkey",
  //     "native": "Türkiye",
  //     "phone": "90",
  //     "continent": "AS",
  //     "capital": "Ankara",
  //     currency: "TRY",
  //     "languages": [
  //       "tr"
  //     ]
  //   },
  //   "TT": {
  //     "name": "Trinidad and Tobago",
  //     "native": "Trinidad and Tobago",
  //     "phone": "1868",
  //     "continent": "NA",
  //     "capital": "Port of Spain",
  //     currency: "TTD",
  //     "languages": [
  //       "en"
  //     ]
  //   },
  //   "TV": {
  //     "name": "Tuvalu",
  //     "native": "Tuvalu",
  //     "phone": "688",
  //     "continent": "OC",
  //     "capital": "Funafuti",
  //     currency: "AUD",
  //     "languages": [
  //       "en"
  //     ]
  //   },
  //   "TW": {
  //     "name": "Taiwan",
  //     "native": "臺灣",
  //     "phone": "886",
  //     "continent": "AS",
  //     "capital": "Taipei",
  //     currency: "TWD",
  //     "languages": [
  //       "zh"
  //     ]
  //   },
  //   "TZ": {
  //     "name": "Tanzania",
  //     "native": "Tanzania",
  //     "phone": "255",
  //     "continent": "AF",
  //     "capital": "Dodoma",
  //     currency: "TZS",
  //     "languages": [
  //       "sw",
  //       "en"
  //     ]
  //   },
  //   "UA": {
  //     "name": "Ukraine",
  //     "native": "Україна",
  //     "phone": "380",
  //     "continent": "EU",
  //     "capital": "Kyiv",
  //     currency: "UAH",
  //     "languages": [
  //       "uk"
  //     ]
  //   },
  //   "UG": {
  //     "name": "Uganda",
  //     "native": "Uganda",
  //     "phone": "256",
  //     "continent": "AF",
  //     "capital": "Kampala",
  //     currency: "UGX",
  //     "languages": [
  //       "en",
  //       "sw"
  //     ]
  //   },
  //   "UM": {
  //     "name": "U.S. Minor Outlying Islands",
  //     "native": "United States Minor Outlying Islands",
  //     "phone": "1",
  //     "continent": "OC",
  //     "capital": "",
  //     currency: "USD",
  //     "languages": [
  //       "en"
  //     ]
  //   },
  //   "US": {
  //     "name": "United States",
  //     "native": "United States",
  //     "phone": "1",
  //     "continent": "NA",
  //     "capital": "Washington D.C.",
  //     currency: "USD,USN,USS",
  //     "languages": [
  //       "en"
  //     ]
  //   },
  //   "UY": {
  //     "name": "Uruguay",
  //     "native": "Uruguay",
  //     "phone": "598",
  //     "continent": "SA",
  //     "capital": "Montevideo",
  //     currency: "UYI,UYU",
  //     "languages": [
  //       "es"
  //     ]
  //   },
  //   "UZ": {
  //     "name": "Uzbekistan",
  //     "native": "O‘zbekiston",
  //     "phone": "998",
  //     "continent": "AS",
  //     "capital": "Tashkent",
  //     currency: "UZS",
  //     "languages": [
  //       "uz",
  //       "ru"
  //     ]
  //   },
  //   "VA": {
  //     "name": "Vatican City",
  //     "native": "Vaticano",
  //     "phone": "39066,379",
  //     "continent": "EU",
  //     "capital": "Vatican City",
  //     currency: "EUROOO",
  //     "languages": [
  //       "it",
  //       "la"
  //     ]
  //   },
  //   "VC": {
  //     "name": "Saint Vincent and the Grenadines",
  //     "native": "Saint Vincent and the Grenadines",
  //     "phone": "1784",
  //     "continent": "NA",
  //     "capital": "Kingstown",
  //     currency: "XCD",
  //     "languages": [
  //       "en"
  //     ]
  //   },
  //   "VE": {
  //     "name": "Venezuela",
  //     "native": "Venezuela",
  //     "phone": "58",
  //     "continent": "SA",
  //     "capital": "Caracas",
  //     currency: "VES",
  //     "languages": [
  //       "es"
  //     ]
  //   },
  //   "VG": {
  //     "name": "British Virgin Islands",
  //     "native": "British Virgin Islands",
  //     "phone": "1284",
  //     "continent": "NA",
  //     "capital": "Road Town",
  //     currency: "USD",
  //     "languages": [
  //       "en"
  //     ]
  //   },
  //   "VI": {
  //     "name": "U.S. Virgin Islands",
  //     "native": "United States Virgin Islands",
  //     "phone": "1340",
  //     "continent": "NA",
  //     "capital": "Charlotte Amalie",
  //     currency: "USD",
  //     "languages": [
  //       "en"
  //     ]
  //   },
  //   "VN": {
  //     "name": "Vietnam",
  //     "native": "Việt Nam",
  //     "phone": "84",
  //     "continent": "AS",
  //     "capital": "Hanoi",
  //     currency: "VND",
  //     "languages": [
  //       "vi"
  //     ]
  //   },
  //   "VU": {
  //     "name": "Vanuatu",
  //     "native": "Vanuatu",
  //     "phone": "678",
  //     "continent": "OC",
  //     "capital": "Port Vila",
  //     currency: "VUV",
  //     "languages": [
  //       "bi",
  //       "en",
  //       "fr"
  //     ]
  //   },
  //   "WF": {
  //     "name": "Wallis and Futuna",
  //     "native": "Wallis et Futuna",
  //     "phone": "681",
  //     "continent": "OC",
  //     "capital": "Mata-Utu",
  //     currency: "XPF",
  //     "languages": [
  //       "fr"
  //     ]
  //   },
  //   "WS": {
  //     "name": "Samoa",
  //     "native": "Samoa",
  //     "phone": "685",
  //     "continent": "OC",
  //     "capital": "Apia",
  //     currency: "WST",
  //     "languages": [
  //       "sm",
  //       "en"
  //     ]
  //   },
  //   "XK": {
  //     "name": "Kosovo",
  //     "native": "Republika e Kosovës",
  //     "phone": "377,381,383,386",
  //     "continent": "EU",
  //     "capital": "Pristina",
  //     currency: "EUROOO",
  //     "languages": [
  //       "sq",
  //       "sr"
  //     ]
  //   },
  //   "YE": {
  //     "name": "Yemen",
  //     "native": "اليَمَن",
  //     "phone": "967",
  //     "continent": "AS",
  //     "capital": "Sana'a",
  //     currency: "YER",
  //     "languages": [
  //       "ar"
  //     ]
  //   },
  //   "YT": {
  //     "name": "Mayotte",
  //     "native": "Mayotte",
  //     "phone": "262",
  //     "continent": "AF",
  //     "capital": "Mamoudzou",
  //     currency: "EUROOO",
  //     "languages": [
  //       "fr"
  //     ]
  //   },
  //   "ZA": {
  //     "name": "South Africa",
  //     "native": "South Africa",
  //     "phone": "27",
  //     "continent": "AF",
  //     "capital": "Pretoria",
  //     currency: "ZAR",
  //     "languages": [
  //       "af",
  //       "en",
  //       "nr",
  //       "st",
  //       "ss",
  //       "tn",
  //       "ts",
  //       "ve",
  //       "xh",
  //       "zu"
  //     ]
  //   },
  //    {
  //     "name": "Zambia",
  //     "native": "Zambia",
  //     "phone": "260",
  //     "continent": "AF",
  //     "capital": "Lusaka",
  //     currency: "ZMK",
  //     "languages": [
  //       "en"
  //     ]
  //   }
  //  {
  //     "name": 'Zimbabwe",
  //     "native": "Zimbabwe",
  //     "phone": "263",
  //     "continent": "AF",
  //     "capital": "Harare",
  //     currency: "USD,ZAR,BWP,GBP,AUD,CNY,INR,JPY",
  //     "languages": [
  //       "en",
  //       "sn",
  //       "nd"
      
    
  ]

  countriess={
    "AD": {
      "name": "Andorra",
      "native": "Andorra",
      "phone": "376",
      "continent": "EU",
      "capital": "Andorra la Vella",
      currency: "EUROOO",
      "languages": [
        "ca"
      ]
    },
    "AE": {
      "name": "United Arab Emirates",
      "native": "دولة الإمارات العربية المتحدة",
      "phone": "971",
      "continent": "AS",
      "capital": "Abu Dhabi",
      currency: "AED",
      "languages": [
        "ar"
      ]
    },
    "AF": {
      "name": "Afghanistan",
      "native": "افغانستان",
      "phone": "93",
      "continent": "AS",
      "capital": "Kabul",
      currency: "AFN",
      "languages": [
        "ps",
        "uz",
        "tk"
      ]
    },
    "AG": {
      "name": "Antigua and Barbuda",
      "native": "Antigua and Barbuda",
      "phone": "1268",
      "continent": "NA",
      "capital": "Saint John's",
      currency: "XCD",
      "languages": [
        "en"
      ]
    },
    "AI": {
      "name": "Anguilla",
      "native": "Anguilla",
      "phone": "1264",
      "continent": "NA",
      "capital": "The Valley",
      currency: "XCD",
      "languages": [
        "en"
      ]
    },
    "AL": {
      "name": "Albania",
      "native": "Shqipëria",
      "phone": "355",
      "continent": "EU",
      "capital": "Tirana",
      currency: "ALL",
      "languages": [
        "sq"
      ]
    },
    "AM": {
      "name": "Armenia",
      "native": "Հայաստան",
      "phone": "374",
      "continent": "AS",
      "capital": "Yerevan",
      currency: "AMD",
      "languages": [
        "hy",
        "ru"
      ]
    },
    "AO": {
      "name": "Angola",
      "native": "Angola",
      "phone": "244",
      "continent": "AF",
      "capital": "Luanda",
      currency: "AOA",
      "languages": [
        "pt"
      ]
    },
    "AQ": {
      "name": "Antarctica",
      "native": "Antarctica",
      "phone": "672",
      "continent": "AN",
      "capital": "",
      currency: "",
      "languages": []
    },
    "AR": {
      "name": "Argentina",
      "native": "Argentina",
      "phone": "54",
      "continent": "SA",
      "capital": "Buenos Aires",
      currency: "ARS",
      "languages": [
        "es",
        "gn"
      ]
    },
    "AS": {
      "name": "American Samoa",
      "native": "American Samoa",
      "phone": "1684",
      "continent": "OC",
      "capital": "Pago Pago",
      currency: "USD",
      "languages": [
        "en",
        "sm"
      ]
    },
    "AT": {
      "name": "Austria",
      "native": "Österreich",
      "phone": "43",
      "continent": "EU",
      "capital": "Vienna",
      currency: "EUROOO",
      "languages": [
        "de"
      ]
    },
    "AU": {
      "name": "Australia",
      "native": "Australia",
      "phone": "61",
      "continent": "OC",
      "capital": "Canberra",
      currency: "AUD",
      "languages": [
        "en"
      ]
    },
    "AW": {
      "name": "Aruba",
      "native": "Aruba",
      "phone": "297",
      "continent": "NA",
      "capital": "Oranjestad",
      currency: "AWG",
      "languages": [
        "nl",
        "pa"
      ]
    },
    "AX": {
      "name": "Åland",
      "native": "Åland",
      "phone": "358",
      "continent": "EU",
      "capital": "Mariehamn",
      currency: "EUROOO",
      "languages": [
        "sv"
      ]
    },
    "AZ": {
      "name": "Azerbaijan",
      currency: "AZN",
    },
    "BA": {
      "name": "Bosnia and Herzegovina",
      currency: "BAM",
    },
    "BB": {
      "name": "Barbados",
      currency: "BBD",
    },
    "BD": {
      "name": "Bangladesh",
      currency: "BDT",
    },
    "BE": {
      "name": "Belgium",
      currency: "EUROOO",
    },
    "BF": {
      "name": "Burkina Faso",
      currency: "XOF",
    },
    "BG": {
      "name": "Bulgaria",
      currency: "BGN",
    },
    "BH": {
      "name": "Bahrain",
      currency: "BHD",
  
    },
    "BI": {
      "name": "Burundi",
      currency: "BIF",
    },
    "BJ": {
      "name": "Benin",
      currency: "XOF",
    },
    "BL": {
      "name": "Saint Barthélemy",
      currency: "EUROOO",
    },
    "BM": {
      "name": "Bermuda",
      currency: "BMD",
    },
    "BN": {
      "name": "Brunei",

      currency: "BND",
    },
    "BO": {
      "name": "Bolivia",

      currency: "BOB,BOV",

    },
    "BQ": {
      "name": "Bonaire",

      currency: "USD",
 
    },
    "BR": {
      "name": "Brazil",

      currency: "BRL",

    },
    "BS": {
      "name": "Bahamas",
 
      currency: "BSD",
  
    },
    "BT": {
      "name": "Bhutan",
 
      currency: "BTN,INR",
 
    },
    "BV": {
      "name": "Bouvet Island",
  
      currency: "NOK",

    },
    "BW": {
      "name": "Botswana",

      currency: "BWP",

    },
    "BY": {
      "name": "Belarus",
  
      currency: "BYR",
     
    },
    "BZ": {
      "name": "Belize",
 
      currency: "BZD",
   
    },
    "CA": {
      "name": "Canada",
  
      currency: "CAD",
   
    },
    "CC": {
      "name": "Cocos [Keeling] Islands",

      currency: "AUD",
  
    },
    "CD": {
      "name": "Democratic Republic of the Congo",
 
      currency: "CDF",
  
    },
    "CF": {
      "name": "Central African Republic",
    
      currency: "XAF",
  
    },
    "CG": {
      "name": "Republic of the Congo",
  
      currency: "XAF",
  
    },
    "CH": {
      "name": "Switzerland",
   
      currency: "CHE,CHF,CHW",
    
    },
    "CI": {
      "name": "Ivory Coast",
 
      currency: "XOF",
    
    },
    "CK": {
      "name": "Cook Islands",
   
      currency: "NZD",
  
    },
    "CL": {
      "name": "Chile",
 
      currency: "CLF,CLP",
    
    },
    "CM": {
      "name": "Cameroon",
     
      currency: "XAF",
   
    },
    "CN": {
      "name": "China",
   
      currency: "CNY",
    
    },
    "CO": {
      "name": "Colombia",
    
      currency: "COP",
     
    },
    "CR": {
      "name": "Costa Rica",
    
      currency: "CRC",
     
    },
    "CU": {
      "name": "Cuba",
  
      currency: "CUC,CUP",
     
    },
    "CV": {
      "name": "Cape Verde",
     
      currency: "CVE",
    
    },
    "CW": {
      "name": "Curacao",
   
      currency: "ANG",
    
    },
    "CX": {
      "name": "Christmas Island",

      currency: "AUD",
   
    },
    "CY": {
      "name": "Cyprus",
   
      currency: "EUROOO",
   
    },
    "CZ": {
      "name": "Czech Republic",
    
      currency: "CZK",
    
    },
    "DE": {
      "name": "Germany",
   
      currency: "EUROOO",
     
    },
    "DJ": {
      "name": "Djibouti",
    
      currency: "DJF",
     
    },
    "DK": {
      "name": "Denmark",
   
      currency: "DKK",

    },
    "DM": {
      "name": "Dominica",
   
      currency: "XCD",
  
    },
    "DO": {
      "name": "Dominican Republic",
   
      currency: "DOP",
     
    },
    "DZ": {
      "name": "Algeria",
 
      currency: "DZD",
     
    },
    "EC": {
      "name": "Ecuador",
  
      currency: "USD",
    
    },
    "EE": {
      "name": "Estonia",
     
      currency: "EUROOO",
     
    },
    "EG": {
      "name": "Egypt",
    
      currency: "EGP",
     
    },
    "EH": {
      "name": "Western Sahara",
  
      currency: "MAD,DZD,MRU",
     
    },
    "ER": {
      "name": "Eritrea",
      
      currency: "ERN",
    
    },
    "ES": {
      "name": "Spain",
  
      currency: "EUROOO",
   
    },
    "ET": {
      "name": "Ethiopia",
  
      currency: "ETB",

    },
    "FI": {
      "name": "Finland",
   
      currency: "EUROOO",
    
    },
    "FJ": {
      "name": "Fiji",
     
      currency: "FJD",
   
    },
    "FK": {
      "name": "Falkland Islands",
   
      currency: "FKP",
   
    },
    "FM": {
      "name": "Micronesia",
     
      currency: "USD",
   
    },
    "FO": {
      "name": "Faroe Islands",
   
      currency: "DKK",
     
    },
    "FR": {
      "name": "France",
    
      currency: "EUROOO",
    
    },
    "GA": {
      "name": "Gabon",
     
      currency: "XAF",
     
    },
    "GB": {
      "name": "United Kingdom",
    
      currency: "GBP",
    
    },
    "GD": {
      "name": "Grenada",
     
      currency: "XCD",
     
    },
    "GE": {
      "name": "Georgia",
     
      currency: "GEL",
    
    },
    "GF": {
      "name": "French Guiana",
  
      currency: "EUROOO",
    
    },
    "GG": {
      "name": "Guernsey",
    
      currency: "GBP",
     
    },
    "GH": {
      "name": "Ghana",
     
      currency: "GHS",
    
    },
    "GI": {
      "name": "Gibraltar",
   
      currency: "GIP",
     
    },
    "GL": {
      "name": "Greenland",
  
      currency: "DKK",
    
    },
    "GM": {
      "name": "Gambia",
 
      currency: "GMD",
    
    },
    "GN": {
      "name": "Guinea",
   
      currency: "GNF",
 
    },
    "GP": {
      "name": "Guadeloupe",
 
      currency: "EUROOO",
    
    },
    "GQ": {
      "name": "Equatorial Guinea",
    
      currency: "XAF",
    
    },
    "GR": {
      "name": "Greece",
      
      currency: "EURO",
     
    },
    "GS": {
      "name": "South Georgia and the South Sandwich Islands",
     
      currency: "GBP",
   
    },
    "GT": {
      "name": "Guatemala",
 
      currency: "GTQ",
  
    },
    "GU": {
      "name": "Guam",
    
      currency: "USD",
  
    },
    "GW": {
      "name": "Guinea-Bissau",

      currency: "XOF",
   
    },
    "GY": {
      "name": "Guyana",
    
      currency: "GYD",
  
    },
    "HK": {
      "name": "Hong Kong",
   
      currency: "HKD",
 
    },
    "HM": {
      "name": "Heard Island and McDonald Islands",
  
      currency: "AUD",
    
    },
    "HN": {
      "name": "Honduras",
   
      currency: "HNL",
     
    },
    "HR": {
      "name": "Croatia",

      currency: "HRK",
  
    },
    "HT": {
      "name": "Haiti",
   
      currency: "HTG,USD",
    
    },
    "HU": {
      "name": "Hungary",
    
      currency: "HUF",
    
    },
    "ID": {
      "name": "Indonesia",
    
      currency: "IDR",
     
    },
    "IE": {
      "name": "Ireland",
  
      currency: "EURO",
    
    },
    "IL": {
      "name": "Israel",
    
      currency: "ILS",
    
    },
    "IM": {
      "name": "Isle of Man",
    
      currency: "GBP",
     
    },
    "IN": {
      "name": "India",
     
      currency: "INR",
      
    },
    "IO": {
      "name": "British Indian Ocean Territory",
   
      currency: "USD",
      
    },
    "IQ": {
      "name": "Iraq",
    
      currency: "IQD",
      
     
    },
    "IR": {
      "name": "Iran",
    
      currency: "IRR",
    
    },
    "IS": {
      "name": "Iceland",
   
      currency: "ISK",
     
    },
    "IT": {
      "name": "Italy",
    
      currency: "EURO",
    
    },
    "JE": {
      "name": "Jersey",
     
      currency: "GBP",
     
    },
    "JM": {
      "name": "Jamaica",
      
      currency: "JMD",
    
    },
    "JO": {
      "name": "Jordan",
  
      currency: "JOD",
    
    },
    "JP": {
      "name": "Japan",
     
      currency: "JPY",
    
    },
    "KE": {
      "name": "Kenya",
    
      currency: "KES",
    
    },
    "KG": {
      "name": "Kyrgyzstan",
    
      currency: "KGS",
  
    },
    "KH": {
      "name": "Cambodia",
    
      currency: "KHR",
     
    },
    "KI": {
      "name": "Kiribati",
    
      currency: "AUD",
    
    },
    "KM": {
      "name": "Comoros",
 
      currency: "KMF",
   
    },
    "KN": {
      "name": "Saint Kitts and Nevis",
  
      currency: "XCD",
     
    },
    "KP": {
      "name": "North Korea",
    
      currency: "KPW",
    
    },
    "KR": {
      "name": "South Korea",
    
      currency: "KRW",
     
    },
    "KW": {
      "name": "Kuwait",
    
      currency: "KWD",
      
    },
    "KY": {
      "name": "Cayman Islands",
  
      currency: "KYD",
   
    },
    "KZ": {
      "name": "Kazakhstan",
     
      currency: "KZT",
     
    },
    "LA": {
      "name": "Laos",
   
      currency: "LAK",
     
    },
    "LB": {
      "name": "Lebanon",
     
      currency: "LBP",
    
    },
    "LC": {
      "name": "Saint Lucia",
   
      currency: "XCD",
    
    },
    "LI": {
      "name": "Liechtenstein",
 
      currency: "CHF",
   
    },
    "LK": {
      "name": "Sri Lanka",
  
      currency: "LKR",
     
    },
    "LR": {
      "name": "Liberia",
     
      currency: "LRD",
   
    },
    "LS": {
      "name": "Lesotho",
  
      currency: "LSL,ZAR",
    
    },
    "LT": {
      "name": "Lithuania",
  
      currency: "EURO",
    
    },
    "LU": {
      "name": "Luxembourg",
  
     currency: "EURO",
   
    
    },
    "LV": {
      "name": "Latvia",
    
      currency: "EURO",
     
    },
    "LY": {
      "name": "Libya",
     
      currency: "LYD",
     
    },
    "MA": {
      "name": "Morocco",
     
      currency: "MAD",
     
    },
    "MC": {
      "name": "Monaco",
     
      currency: "EURO",
  
    },
    "MD": {
      "name": "Moldova",
    
      currency: "MDL",
     
    },
    "ME": {
      "name": "Montenegro",
    
      currency: "EURO",
    
    },
    "MF": {
      "name": "Saint Martin",
      
      currency: "EURO",
   
    },
    "MG": {
      "name": "Madagascar",

      currency: "MGA",
   
    },
    "MH": {
      "name": "Marshall Islands",
  
      currency: "USD",
   
    },
    "MK": {
      "name": "North Macedonia",
   
      currency: "MKD",
    
    },
    "ML": {
      "name": "Mali",
    
      currency: "XOF",
  
    },
    "MM": {
      "name": "Myanmar [Burma]",
   
      currency: "MMK",
    
    },
    "MN": {
      "name": "Mongolia",
    
      currency: "MNT",
   
    },
    "MO": {
      "name": "Macao",
     
      currency: "MOP",
    
    },
    "MP": {
      "name": "Northern Mariana Islands",
    
      currency: "USD",
   
    },
    "MQ": {
      "name": "Martinique",
    
      currency: "EURO",
   
    },
    "MR": {
      "name": "Mauritania",
     
      currency: "MRU",
   
    },
    "MS": {
      "name": "Montserrat",
     
      currency: "XCD",
  
    },
    "MT": {
      "name": "Malta",
    
      currency: "EURO",
     
    },
    "MU": {
      "name": "Mauritius",
  
      currency: "MUR",
   
    },
    "MV": {
      "name": "Maldives",
    
      currency: "MVR",
   
    },
    "MW": {
      "name": "Malawi",
    
      currency: "MWK",
   
    },
    "MX": {
      "name": "Mexico",
   
      currency: "MXN",
     
    },
    "MY": {
      "name": "Malaysia",
  
      currency: "MYR",
    
    },
    "MZ": {
      "name": "Mozambique",
   
      currency: "MZN",
   
    },
    "NA": {
      "name": "Namibia",
    
      currency: "NAD,ZAR",
   
    },
    "NC": {
      "name": "New Caledonia",
    
      currency: "XPF",
    
    },
    "NE": {
      "name": "Niger",
     
      currency: "XOF",
  
    },
    "NF": {
      "name": "Norfolk Island",
    
      currency: "AUD",
  
    },
    "NG": {
      "name": "Nigeria",
      
      currency: "NGN",
     
    },
    "NI": {
      "name": "Nicaragua",
    
      currency: "NIO",
     
    },
    "NL": {
      "name": "Netherlands",
  
      currency: "EURO",
   
    },
    "NO": {
      "name": "Norway",
     
      currency: "NOK",
   
    },
    "NP": {
      "name": "Nepal",
   
      currency: "NPR",
     
    },
    "NR": {
      "name": "Nauru",
    
      currency: "AUD",
      
    },
    "NU": {
      "name": "Niue",
   
      currency: "NZD",
     
    },
    "NZ": {
      "name": "New Zealand",
      
      currency: "NZD",
     
    },
    "OM": {
      "name": "Oman",
   
      currency: "OMR",
     
    },
    "PA": {
      "name": "Panama",
    
      currency: "PAB,USD",
    
    },
    "PE": {
      "name": "Peru",
   
      currency: "PEN",
   
    },
    "PF": {
      "name": "French Polynesia",
   
      currency: "XPF",
    
    },
    "PG": {
      "name": "Papua New Guinea",
   
      currency: "PGK",
    
    },
    "PH": {
      "name": "Philippines",
   
      currency: "PHP",
    
    },
    "PK": {
      "name": "Pakistan",
    
      currency: "PKR",
   
    },
    "PL": {
      "name": "Poland",
  
      currency: "PLN",
  
    },
    "PM": {
      "name": "Saint Pierre and Miquelon",
     
      currency: "EURO",
  
    },
    "PN": {
      "name": "Pitcairn Islands",
     
      currency: "NZD",
     
    },
    "PR": {
      "name": "Puerto Rico",
     
      currency: "USD",
  
    },
    "PS": {
      "name": "Palestine",
     
      currency: "ILS",
 
    },
    "PT": {
      "name": "Portugal",
 
      currency: "EURO",
    
    },
    "PW": {
      "name": "Palau",
    
      currency: "USD",
   
    },
    "PY": {
      "name": "Paraguay",
     
      currency: "PYG",
  
    },
    "QA": {
      "name": "Qatar",
     
      currency: "QAR",
     
    },
    "RE": {
      "name": "Réunion",
   
      currency: "EURO",
 
    },
    "RO": {
      "name": "Romania",
    
      currency: "RON",
    
    },
    "RS": {
      "name": "Serbia",
  
      currency: "RSD",
   
    },
    "RU": {
      "name": "Russia",
    
      currency: "RUB",
    
    },
    "RW": {
      "name": "Rwanda",
     
      currency: "RWF",
   
    },
    "SA": {
      "name": "Saudi Arabia",
     
      currency: "SAR",
  
    },
    "SB": {
      "name": "Solomon Islands",
  
      currency: "SBD",
     
    },
    "SC": {
      "name": "Seychelles",
    
      currency: "SCR",
     
    },
    "SD": {
      "name": "Sudan",
   
      currency: "SDG",
   
    },
    "SE": {
      "name": "Sweden",
   
      currency: "SEK",
   
    },
    "SG": {
      "name": "Singapore",
     
      currency: "SGD",
     
    },
    "SH": {
      "name": "Saint Helena",
     
      currency: "SHP",
   
    },
    "SI": {
      "name": "Slovenia",
    
      currency: "EURO",
   
    },
    "SJ": {
      "name": "Svalbard and Jan Mayen",
   
      currency: "NOK",
      
    },
    "SK": {
      "name": "Slovakia",
      
      currency: "EURO",
   
    },
    "SL": {
      "name": "Sierra Leone",
     
      currency: "SLL",
     
    },
    "SM": {
      "name": "San Marino",
   
      currency: "EURO",
     
    },
    "SN": {
      "name": "Senegal",
     
      currency: "XOF",
  
    },
    "SO": {
      "name": "Somalia",
    
      currency: "SOS",
  
    },
    "SR": {
      "name": "Suriname",
 
      currency: "SRD",
   
    },
    "SS": {
      "name": "South Sudan",
    
      currency: "SSP",
   
    },
    "ST": {
      "name": "São Tomé and Príncipe",
   
      currency: "STN",
     
    },
    "SV": {
      "name": "El Salvador",
    
      currency: "SVC,USD",
    
    },
    "SX": {
      "name": "Sint Maarten",
   
      currency: "ANG",
    
    },
    "SY": {
      "name": "Syria",
    
      currency: "SYP",
     
    },
    "SZ": {
      "name": "Swaziland",
    
      currency: "SZL",
   
    },
    "TC": {
      "name": "Turks and Caicos Islands",
  
      currency: "USD",
     
    },
    "TD": {
      "name": "Chad",
     
      currency: "XAF",
    
    },
    "TF": {
      "name": "French Southern Territories",
 
      currency: "EURO",
    
    },
    "TG": {
      "name": "Togo",
    
      currency: "XOF",
     
    },
    "TH": {
      "name": "Thailand",
   
      currency: "THB",
   
    },
    "TJ": {
      "name": "Tajikistan",
    
      currency: "TJS",
    
    },
    "TK": {
      "name": "Tokelau",
   
      currency: "NZD",
    
    },
    "TL": {
      "name": "East Timor",
     
      currency: "USD",
     
    },
    "TM": {
      "name": "Turkmenistan",
     
      currency: "TMT",
   
    },
    "TN": {
      "name": "Tunisia",
    
      currency: "TND",
   
    },
    "TO": {
      "name": "Tonga",
    
      currency: "TOP",

    },
    "TR": {
      "name": "Turkey",
   
      currency: "TRY",
     
    },
    "TT": {
      "name": "Trinidad and Tobago",

    
      currency: "TTD",
     
    },
    "TV": {
      "name": "Tuvalu",
  
      currency: "AUD",
     
      
    },
    "TW": {
      "name": "Taiwan",
    
      currency: "TWD",
     
    },
    "TZ": {
      "name": "Tanzania",
    
      currency: "TZS",
     
    },
    "UA": {
      "name": "Ukraine",
     
    
      currency: "UAH",
    
    },
    "UG": {
      "name": "Uganda",
  
      currency: "UGX",
     
    },
    "UM": {
      "name": "U.S. Minor Outlying Islands",
    
      currency: "USD",
    
    },
    "US": {
      "name": "United States",
  
      currency: "USD,USN,USS",
   
    },
    "UY": {
      "name": "Uruguay",
    
      currency: "UYI,UYU",
   
    },
    "UZ": {
      "name": "Uzbekistan",
   
      currency: "UZS",
  
    },
    "VA": {
      "name": "Vatican City",
     
      currency: "EURO",
    
    },
    "VC": {
      "name": "Saint Vincent and the Grenadines",
  
      currency: "XCD",
     
    },
    "VE": {
      "name": "Venezuela",
    
      currency: "VES",
    
    },
    "VG": {
      "name": "British Virgin Islands",
     
      currency: "USD",
     
    },
    "VI": {
      "name": "U.S. Virgin Islands",
    
      currency: "USD",
    
    },
    "VN": {
      "name": "Vietnam",
   
      currency: "VND",
     
    },
    "VU": {
      "name": "Vanuatu",
    
      currency: "VUV",
   
    },
    "WF": {
      "name": "Wallis and Futuna",
  
      currency: "XPF",
     
    },
    "WS": {
      "name": "Samoa",
 
      currency: "WST",
    
    },
    "XK": {
      "name": "Kosovo",
  
      currency: "EURO",
     
    },
    "YE": {
      "name": "Yemen",
   
      currency: "YER",
     
    },
    "YT": {
      "name": "Mayotte",
     
      currency: "EURO",
   
    },
    "ZA": {
      "name": "South Africa",
    
      currency: "ZAR",
    
    },
    "ZM": {
      "name": "Zambia",
 
      currency: "ZMK",
  
    },
    "ZW": {
      "name": "Zimbabwe",
    
      currency: "USD,ZAR,BWP,GBP,AUD,CNY,INR,JPY",
    
    }
  }
  languagesDF=[
    {"code":"en","name":"English","nativeName":"English"},
    // {"code":"en-AU","name":"English - Australia","nativeName":"English - Australia"},
    // {"code":"en-CA","name":"English - Canada","nativeName":"English - Canada"},
    // {"code":"en-GB","name":"English - Great Britain","nativeName":"English - Great Britain"},
    // {"code":"en-IN","name":"English - India","nativeName":"English - India"},
    // {"code":"en-US","name":"English - US","nativeName":"English - US"},
    {"code":"fr","name":"French","nativeName":"French"},
    // {"code":"fr-CA","name":"French - Canada","nativeName":"French - Canada"},
    // {"code":"fr-FR","name":"French - France","nativeName":"French - France"},
    {"code":"de","name":"German","nativeName":"German"},
    {"code":"zh-HK","name":"Chinese - Cantonese","nativeName":"Chinese - Cantonese"},
    // {"code":"zh-CN","name":"Chinese - Simplified","nativeName":"Chinese - Simplified"},
    // {"code":"zh-TW","name":"Chinese - Traditional","nativeName":"Chinese - Traditional"},
    {"code":"da","name":"Danish","nativeName":"Danish"},
    ////
    {"code":"nl","name":"Dutch","nativeName":"Dutch"},
    {"code":"hi","name":"Hindi","nativeName":"Hindi"},
    {"code":"it","name":"Indonesian","nativeName":"Indonesian"},
    {"code":"be","name":"Italian","nativeName":"Italian"},
    {"code":"ja","name":"BenJapanesegali","nativeName":"Japanese"},
    {"code":"ko","name":"Korean","nativeName":"Korean"},
    {"code":"no","name":"Norwegian","nativeName":"Norwegian"},
    {"code":"pl","name":"Polish","nativeName":"Polish"},
    // {"code":"pt-BR","name":"Portuguese - Brazil","nativeName":"Portuguese - Brazil"},
    {"code":"pt","name":"Portuguese - Portugal","nativeName":"Portuguese - Portugal"},
    {"code":"ru","name":"Russian","nativeName":"Russian"},
    {"code":"es","name":"Spanish","nativeName":"Spanish"},
    // {"code":"es-419","name":"Spanish - Latin America","nativeName":"Spanish - Latin America"},
    {"code":"es-ES","name":"Spanish - Spain","nativeName":"Spanish - Spain"},
    {"code":"sv","name":"Swedish","nativeName":"Swedish"},
    {"code":"th","name":"Thai","nativeName":"Thai"},
    {"code":"tr","name":"Turkish","nativeName":"Turkish"},
    {"code":"uk","name":"Ukranian","nativeName":"Ukranian"},
  ]
  languagesCT=[
    {"code":"en","name":"English","nativeName":"English"},
    {"code":"fr","name":"French","nativeName":"French"},
    {"code":"de","name":"German","nativeName":"German"},
    {"code":"zh-HK","name":"Chinese - Cantonese","nativeName":"Chinese - Cantonese"},
    {"code":"da","name":"Danish","nativeName":"Danish"},
    {"code":"nl","name":"Dutch","nativeName":"Dutch"},
    {"code":"hi","name":"Hindi","nativeName":"Hindi"},
    {"code":"it","name":"Indonesian","nativeName":"Indonesian"},
    {"code":"be","name":"Italian","nativeName":"Italian"},
    {"code":"ja","name":"BenJapanesegali","nativeName":"Japanese"},
    {"code":"ko","name":"Korean","nativeName":"Korean"},
    {"code":"no","name":"Norwegian","nativeName":"Norwegian"},
    {"code":"pl","name":"Polish","nativeName":"Polish"},
    {"code":"pt-BR","name":"Portuguese - Brazil","nativeName":"Portuguese - Brazil"},
    {"code":"pt","name":"Portuguese - Portugal","nativeName":"Portuguese - Portugal"},
    {"code":"ru","name":"Russian","nativeName":"Russian"},
    {"code":"es","name":"Spanish","nativeName":"Spanish"},
    {"code":"sv","name":"Swedish","nativeName":"Swedish"},
    {"code":"th","name":"Thai","nativeName":"Thai"},
    {"code":"tr","name":"Turkish","nativeName":"Turkish"},
    {"code":"uk","name":"Ukranian","nativeName":"Ukranian"},
  ]


  languages=[
    {"code":"ab","name":"Abkhaz","nativeName":"аҧсуа"},
    {"code":"aa","name":"Afar","nativeName":"Afaraf"},
    {"code":"af","name":"Afrikaans","nativeName":"Afrikaans"},
    {"code":"ak","name":"Akan","nativeName":"Akan"},
    {"code":"sq","name":"Albanian","nativeName":"Shqip"},
    {"code":"am","name":"Amharic","nativeName":"አማርኛ"},
    {"code":"ar","name":"Arabic","nativeName":"العربية"},
    {"code":"an","name":"Aragonese","nativeName":"Aragonés"},
    {"code":"hy","name":"Armenian","nativeName":"Հայերեն"},
    {"code":"as","name":"Assamese","nativeName":"অসমীয়া"},
    {"code":"av","name":"Avaric","nativeName":"авар мацӀ, магӀарул мацӀ"},
    {"code":"ae","name":"Avestan","nativeName":"avesta"},
    {"code":"ay","name":"Aymara","nativeName":"aymar aru"},
    {"code":"az","name":"Azerbaijani","nativeName":"azərbaycan dili"},
    {"code":"bm","name":"Bambara","nativeName":"bamanankan"},
    {"code":"ba","name":"Bashkir","nativeName":"башҡорт теле"},
    {"code":"eu","name":"Basque","nativeName":"euskara, euskera"},
    {"code":"be","name":"Belarusian","nativeName":"Беларуская"},
    {"code":"bn","name":"Bengali","nativeName":"বাংলা"},
    {"code":"bh","name":"Bihari","nativeName":"भोजपुरी"},
    {"code":"bi","name":"Bislama","nativeName":"Bislama"},
    {"code":"bs","name":"Bosnian","nativeName":"bosanski jezik"},
    {"code":"br","name":"Breton","nativeName":"brezhoneg"},
    {"code":"bg","name":"Bulgarian","nativeName":"български език"},
    {"code":"my","name":"Burmese","nativeName":"ဗမာစာ"},
    {"code":"ca","name":"Catalan; Valencian","nativeName":"Català"},
    {"code":"ch","name":"Chamorro","nativeName":"Chamoru"},
    {"code":"ce","name":"Chechen","nativeName":"нохчийн мотт"},
    {"code":"ny","name":"Chichewa; Chewa; Nyanja","nativeName":"chiCheŵa, chinyanja"},
    {"code":"zh","name":"Chinese","nativeName":"中文 (Zhōngwén), 汉语, 漢語"},
    {"code":"cv","name":"Chuvash","nativeName":"чӑваш чӗлхи"},
    {"code":"kw","name":"Cornish","nativeName":"Kernewek"},
    {"code":"co","name":"Corsican","nativeName":"corsu, lingua corsa"},
    {"code":"cr","name":"Cree","nativeName":"ᓀᐦᐃᔭᐍᐏᐣ"},
    {"code":"hr","name":"Croatian","nativeName":"hrvatski"},
    {"code":"cs","name":"Czech","nativeName":"česky, čeština"},
    {"code":"da","name":"Danish","nativeName":"dansk"},
    {"code":"dv","name":"Divehi; Dhivehi; Maldivian;","nativeName":"ދިވެހި"},
    {"code":"nl","name":"Dutch","nativeName":"Nederlands, Vlaams"},
    {"code":"en","name":"English","nativeName":"English"},
    {"code":"eo","name":"Esperanto","nativeName":"Esperanto"},
    {"code":"et","name":"Estonian","nativeName":"eesti, eesti keel"},
    {"code":"ee","name":"Ewe","nativeName":"Eʋegbe"},
    {"code":"fo","name":"Faroese","nativeName":"føroyskt"},
    {"code":"fj","name":"Fijian","nativeName":"vosa Vakaviti"},
    {"code":"fi","name":"Finnish","nativeName":"suomi, suomen kieli"},
    {"code":"fr","name":"French","nativeName":"français, langue française"},
    {"code":"ff","name":"Fula; Fulah; Pulaar; Pular","nativeName":"Fulfulde, Pulaar, Pular"},
    {"code":"gl","name":"Galician","nativeName":"Galego"},
    {"code":"ka","name":"Georgian","nativeName":"ქართული"},
    {"code":"de","name":"German","nativeName":"Deutsch"},
    {"code":"el","name":"Greek, Modern","nativeName":"Ελληνικά"},
    {"code":"gn","name":"Guaraní","nativeName":"Avañeẽ"},
    {"code":"gu","name":"Gujarati","nativeName":"ગુજરાતી"},
    {"code":"ht","name":"Haitian; Haitian Creole","nativeName":"Kreyòl ayisyen"},
    {"code":"ha","name":"Hausa","nativeName":"Hausa, هَوُسَ"},
    {"code":"he","name":"Hebrew (modern)","nativeName":"עברית"},
    {"code":"hz","name":"Herero","nativeName":"Otjiherero"},
    {"code":"hi","name":"Hindi","nativeName":"हिन्दी, हिंदी"},
    {"code":"ho","name":"Hiri Motu","nativeName":"Hiri Motu"},
    {"code":"hu","name":"Hungarian","nativeName":"Magyar"},
    {"code":"ia","name":"Interlingua","nativeName":"Interlingua"},
    {"code":"id","name":"Indonesian","nativeName":"Bahasa Indonesia"},
    {"code":"ie","name":"Interlingue","nativeName":"Originally called Occidental; then Interlingue after WWII"},
    {"code":"ga","name":"Irish","nativeName":"Gaeilge"},
    {"code":"ig","name":"Igbo","nativeName":"Asụsụ Igbo"},
    {"code":"ik","name":"Inupiaq","nativeName":"Iñupiaq, Iñupiatun"},
    {"code":"io","name":"Ido","nativeName":"Ido"},
    {"code":"is","name":"Icelandic","nativeName":"Íslenska"},
    {"code":"it","name":"Italian","nativeName":"Italiano"},
    {"code":"iu","name":"Inuktitut","nativeName":"ᐃᓄᒃᑎᑐᑦ"},
    {"code":"ja","name":"Japanese","nativeName":"日本語 (にほんご／にっぽんご)"},
    {"code":"jv","name":"Javanese","nativeName":"basa Jawa"},
    {"code":"kl","name":"Kalaallisut, Greenlandic","nativeName":"kalaallisut, kalaallit oqaasii"},
    {"code":"kn","name":"Kannada","nativeName":"ಕನ್ನಡ"},
    {"code":"kr","name":"Kanuri","nativeName":"Kanuri"},
    {"code":"ks","name":"Kashmiri","nativeName":"कश्मीरी, كشميري‎"},
    {"code":"kk","name":"Kazakh","nativeName":"Қазақ тілі"},
    {"code":"km","name":"Khmer","nativeName":"ភាសាខ្មែរ"},
    {"code":"ki","name":"Kikuyu, Gikuyu","nativeName":"Gĩkũyũ"},
    {"code":"rw","name":"Kinyarwanda","nativeName":"Ikinyarwanda"},
    {"code":"ky","name":"Kirghiz, Kyrgyz","nativeName":"кыргыз тили"},
    {"code":"kv","name":"Komi","nativeName":"коми кыв"},
    {"code":"kg","name":"Kongo","nativeName":"KiKongo"},
    {"code":"ko","name":"Korean","nativeName":"한국어 (韓國語), 조선말 (朝鮮語)"},
    {"code":"ku","name":"Kurdish","nativeName":"Kurdî, كوردی‎"},
    {"code":"kj","name":"Kwanyama, Kuanyama","nativeName":"Kuanyama"},
    {"code":"la","name":"Latin","nativeName":"latine, lingua latina"},
    {"code":"lb","name":"Luxembourgish, Letzeburgesch","nativeName":"Lëtzebuergesch"},
    {"code":"lg","name":"Luganda","nativeName":"Luganda"},
    {"code":"li","name":"Limburgish, Limburgan, Limburger","nativeName":"Limburgs"},
    {"code":"ln","name":"Lingala","nativeName":"Lingála"},
    {"code":"lo","name":"Lao","nativeName":"ພາສາລາວ"},
    {"code":"lt","name":"Lithuanian","nativeName":"lietuvių kalba"},
    {"code":"lu","name":"Luba-Katanga","nativeName":""},
    {"code":"lv","name":"Latvian","nativeName":"latviešu valoda"},
    {"code":"gv","name":"Manx","nativeName":"Gaelg, Gailck"},
    {"code":"mk","name":"Macedonian","nativeName":"македонски јазик"},
    {"code":"mg","name":"Malagasy","nativeName":"Malagasy fiteny"},
    {"code":"ms","name":"Malay","nativeName":"bahasa Melayu, بهاس ملايو‎"},
    {"code":"ml","name":"Malayalam","nativeName":"മലയാളം"},
    {"code":"mt","name":"Maltese","nativeName":"Malti"},
    {"code":"mi","name":"Māori","nativeName":"te reo Māori"},
    {"code":"mr","name":"Marathi (Marāṭhī)","nativeName":"मराठी"},
    {"code":"mh","name":"Marshallese","nativeName":"Kajin M̧ajeļ"},
    {"code":"mn","name":"Mongolian","nativeName":"монгол"},
    {"code":"na","name":"Nauru","nativeName":"Ekakairũ Naoero"},
    {"code":"nv","name":"Navajo, Navaho","nativeName":"Diné bizaad, Dinékʼehǰí"},
    {"code":"nb","name":"Norwegian Bokmål","nativeName":"Norsk bokmål"},
    {"code":"nd","name":"North Ndebele","nativeName":"isiNdebele"},
    {"code":"ne","name":"Nepali","nativeName":"नेपाली"},
    {"code":"ng","name":"Ndonga","nativeName":"Owambo"},
    {"code":"nn","name":"Norwegian Nynorsk","nativeName":"Norsk nynorsk"},
    {"code":"no","name":"Norwegian","nativeName":"Norsk"},
    {"code":"ii","name":"Nuosu","nativeName":"ꆈꌠ꒿ Nuosuhxop"},
    {"code":"nr","name":"South Ndebele","nativeName":"isiNdebele"},
    {"code":"oc","name":"Occitan","nativeName":"Occitan"},
    {"code":"oj","name":"Ojibwe, Ojibwa","nativeName":"ᐊᓂᔑᓈᐯᒧᐎᓐ"},
    {"code":"cu","name":"Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic","nativeName":"ѩзыкъ словѣньскъ"},
    {"code":"om","name":"Oromo","nativeName":"Afaan Oromoo"},
    {"code":"or","name":"Oriya","nativeName":"ଓଡ଼ିଆ"},
    {"code":"os","name":"Ossetian, Ossetic","nativeName":"ирон æвзаг"},
    {"code":"pa","name":"Panjabi, Punjabi","nativeName":"ਪੰਜਾਬੀ, پنجابی‎"},
    {"code":"pi","name":"Pāli","nativeName":"पाऴि"},
    {"code":"fa","name":"Persian","nativeName":"فارسی"},
    {"code":"pl","name":"Polish","nativeName":"polski"},
    {"code":"ps","name":"Pashto, Pushto","nativeName":"پښتو"},
    {"code":"pt","name":"Portuguese","nativeName":"Português"},
    {"code":"qu","name":"Quechua","nativeName":"Runa Simi, Kichwa"},
    {"code":"rm","name":"Romansh","nativeName":"rumantsch grischun"},
    {"code":"rn","name":"Kirundi","nativeName":"kiRundi"},
    {"code":"ro","name":"Romanian, Moldavian, Moldovan","nativeName":"română"},
    {"code":"ru","name":"Russian","nativeName":"русский язык"},
    {"code":"sa","name":"Sanskrit (Saṁskṛta)","nativeName":"संस्कृतम्"},
    {"code":"sc","name":"Sardinian","nativeName":"sardu"},
    {"code":"sd","name":"Sindhi","nativeName":"सिन्धी, سنڌي، سندھی‎"},
    {"code":"se","name":"Northern Sami","nativeName":"Davvisámegiella"},
    {"code":"sm","name":"Samoan","nativeName":"gagana faa Samoa"},
    {"code":"sg","name":"Sango","nativeName":"yângâ tî sängö"},
    {"code":"sr","name":"Serbian","nativeName":"српски језик"},
    {"code":"gd","name":"Scottish Gaelic; Gaelic","nativeName":"Gàidhlig"},
    {"code":"sn","name":"Shona","nativeName":"chiShona"},
    {"code":"si","name":"Sinhala, Sinhalese","nativeName":"සිංහල"},
    {"code":"sk","name":"Slovak","nativeName":"slovenčina"},
    {"code":"sl","name":"Slovene","nativeName":"slovenščina"},
    {"code":"so","name":"Somali","nativeName":"Soomaaliga, af Soomaali"},
    {"code":"st","name":"Southern Sotho","nativeName":"Sesotho"},
    {"code":"es","name":"Spanish; Castilian","nativeName":"español, castellano"},
    {"code":"su","name":"Sundanese","nativeName":"Basa Sunda"},
    {"code":"sw","name":"Swahili","nativeName":"Kiswahili"},
    {"code":"ss","name":"Swati","nativeName":"SiSwati"},
    {"code":"sv","name":"Swedish","nativeName":"svenska"},
    {"code":"ta","name":"Tamil","nativeName":"தமிழ்"},
    {"code":"te","name":"Telugu","nativeName":"తెలుగు"},
    {"code":"tg","name":"Tajik","nativeName":"тоҷикӣ, toğikī, تاجیکی‎"},
    {"code":"th","name":"Thai","nativeName":"ไทย"},
    {"code":"ti","name":"Tigrinya","nativeName":"ትግርኛ"},
    {"code":"bo","name":"Tibetan Standard, Tibetan, Central","nativeName":"བོད་ཡིག"},
    {"code":"tk","name":"Turkmen","nativeName":"Türkmen, Түркмен"},
    {"code":"tl","name":"Tagalog","nativeName":"Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"},
    {"code":"tn","name":"Tswana","nativeName":"Setswana"},
    {"code":"to","name":"Tonga (Tonga Islands)","nativeName":"faka Tonga"},
    {"code":"tr","name":"Turkish","nativeName":"Türkçe"},
    {"code":"ts","name":"Tsonga","nativeName":"Xitsonga"},
    {"code":"tt","name":"Tatar","nativeName":"татарча, tatarça, تاتارچا‎"},
    {"code":"tw","name":"Twi","nativeName":"Twi"},
    {"code":"ty","name":"Tahitian","nativeName":"Reo Tahiti"},
    {"code":"ug","name":"Uighur, Uyghur","nativeName":"Uyƣurqə, ئۇيغۇرچە‎"},
    {"code":"uk","name":"Ukrainian","nativeName":"українська"},
    {"code":"ur","name":"Urdu","nativeName":"اردو"},
    {"code":"uz","name":"Uzbek","nativeName":"zbek, Ўзбек, أۇزبېك‎"},
    {"code":"ve","name":"Venda","nativeName":"Tshivenḓa"},
    {"code":"vi","name":"Vietnamese","nativeName":"Tiếng Việt"},
    {"code":"vo","name":"Volapük","nativeName":"Volapük"},
    {"code":"wa","name":"Walloon","nativeName":"Walon"},
    {"code":"cy","name":"Welsh","nativeName":"Cymraeg"},
    {"code":"wo","name":"Wolof","nativeName":"Wollof"},
    {"code":"fy","name":"Western Frisian","nativeName":"Frysk"},
    {"code":"xh","name":"Xhosa","nativeName":"isiXhosa"},
    {"code":"yi","name":"Yiddish","nativeName":"ייִדיש"},
    {"code":"yo","name":"Yoruba","nativeName":"Yorùbá"},
    {"code":"za","name":"Zhuang, Chuang","nativeName":"Saɯ cueŋƅ, Saw cuengh"}
  ]

  currencyDF=[
    {
       "currency": "EURO",
     },
    {
       "currency": "AED",
     },
    {
       "currency": "AFN",
     },
    {
       "currency": "XCD",
     },
   {
       "currency": "XCD",
     },
  {
       "currency": "ALL",
     },
   {
       "currency": "AMD",
     },
    {
       "currency": "AOA",
     },
     {
       "currency": "",
     },
    {
       "currency": "ARS",
     },
    {
       "currency": "USD",
     },
     {
       "currency": "EURO",
 
     },
  {
       "currency": "AUD",
     },
     {
       "currency": "AWG",
     },
    {
 
       "currency": "EURO",
     },
     {
       "currency": "AZN",
     },
    {
       "currency": "BAM",
     },
   {
       "currency": "BBD",
     },
    {
       "currency": "BDT",
     },
   {
       "currency": "EURO",
     },
  {
       "currency": "XOF",
     },
    {
       "currency": "BGN",
     },
    {
       "currency": "BHD",
     },
      {
       "currency": "BIF",
 
     },
     {
       "currency": "XOF",
     
     },
   {
       "currency": "EURO",
      
     },
   {
       "currency": "BMD",
    
     },
  {
       "currency": "BND",
    
     },
  {
       "currency": "BOB,BOV",
     
     },
    {
       "currency": "USD",
     
     },
  {
       "currency": "BRL",
     
     },
  {
       "currency": "BSD",
      
     },
   {
       "currency": "BTN,INR",
      
     },
    {
       "currency": "NOK",
     
     },
    {
       "currency": "BWP",
    
     },
     {
       "currency": "BYR",
      
     },
      {
       "currency": "BZD",
   
     },
   {
       "currency": "CAD",
     
     },
    {
       "currency": "AUD",
     
     },
    {
       "currency": "CDF",
    
     },
     {
       "currency": "XAF",
     
     },
   {
       "currency": "XAF",
    
     },
  {
       "currency": "CHE,CHF,CHW",
     
     },
    {
       "currency": "XOF",
    
     },
    {
       "currency": "NZD",
     
     },
    {
 
       "currency": "CLF,CLP",
     
     },
   {
       "currency": "XAF",
   
     },
   {
       "currency": "CNY",
     
     },
      {
       "currency": "COP",
    
     },
      {
       "currency": "CRC",
    
     },
    {
       "currency": "CUC,CUP",
     
     },
   {
       "currency": "ANG",
     
     },
   {
       "currency": "AUD",
    
     },
     {
       "currency": "EURO",
   
     },
   {
       "currency": "CZK",
    
     },
   {
       "currency": "EURO",
    
     },
  {
       "currency": "DJF",
   
     },
     {
       "currency": "DKK",
    
     },
    {
       "currency": "XCD",
    },
  {
       "currency": "DOP",
    
     },
   {
       "currency": "DZD",
     
     },
  {
       "currency": "USD",
     
     },
  {
       "currency": "EURO",
      
     },
    {
       "currency": "EGP",
   
     },
   {

       "currency": "MAD,DZD,MRU",
   
     },
     { "currency": "ERN",
   
     },
    {
       "currency": "EURO",
   
     },
    {
       "currency": "ETB",
  
     },
     {
       "currency": "EURO",
     
     },
    {
       "currency": "FJD",
   
     },
   {
       "currency": "FKP",
    
     },
    {
       "currency": "USD",
   
     },
  {
       "currency": "DKK",
    
     },
      {
       "currency": "EURO",
     
     },
   {
       "currency": "XAF",
    
     },
     {
       "currency": "GBP",
    
     },
   
    {
 "currency": "GEL",
   
     },
    {
       "currency": "EURO",
   
     },
    {
       "currency": "GBP",
    
     },
     {
       "currency": "GHS",
      
     },
   {
     
       "currency": "GIP",
     
     },
  {
       "currency": "DKK",
    
     },
  {
       "currency": "GMD",
     
     },
      {
       "currency": "GNF",
     
     },
 {
       "currency": "EURO",
     
       
     },
   {
       "currency": "XAF",
    
     },
  {
       "currency": "EURO",
      
     },
    {
       "currency": "GBP",
    
     },
     {
       "currency": "GTQ",
     
     },
   {
       "currency": "USD",
   
     },
    {
       "currency": "XOF",
    
     },
    {
       "currency": "GYD",
     
     },
    {
       "currency": "HKD",
    
     },
   {
       "currency": "AUD",
      
     },
     {
       "currency": "HNL",
    
     },
    {
       "currency": "HRK",
      
     },
    {
       "currency": "HTG,USD",
     
     },
  {
       "currency": "HUF",
     
     },
      {
       "currency": "IDR",
     
     },
  {
       "currency": "EURO",
  
     },
     { "currency": "ILS",
   
     },
      {
       "currency": "GBP",
     
     },
   {
       "currency": "INR",
     
     },
   {
       "currency": "USD",
     
     },
    {
       "currency": "IQD",
     
     },
     {
       "currency": "IRR",
     
     },
    {
       "currency": "ISK",
      
     },
    {
       "currency": "EURO",
     
     },
   {
       "currency": "GBP",
      
     },
     {
       "currency": "JMD",
     
     },
    {
       "currency": "JOD",
     
     },
    {
       "currency": "JPY",
   
     },
  {
       "currency": "KES",
   
     },
    {
       "currency": "KGS",
     
       
     },
   {
       "currency": "KHR",
     
     },
    {

       "currency": "AUD",
     
     },
  {

       "currency": "KMF",
    
     },
      {

       "currency": "XCD",
     
     },
     {
       "currency": "KPW",
    
     },
    {
       "currency": "KRW",
     
     },   
   ]
  constructor() { }
  getAllLanguage(){
    return this.languagesDF;
  }
  getByKey(key : any){
    Object.keys(this.languagesDF).map(a=>{
      return this.languagesDF[key];
    })
  }
  getAllCountry(){
    return this.countries;
  }
  getAllCountryBycode(){
    return this.countries;
  }
  getCatalogLanguage(){
    return this.languagesCT;
  }

  getCurrency(){
    return this.currencyDF;
  }
  getAllLanguageAlexa(){
    return this.languagesAlexa;
  }
}
